/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
 */
import App from './App';
import router, { resetRouter } from './router';
import store from './store';
// 解决Added non-passive event listener to a scroll-blocking 'mousewheel' event. Consider marking event han
// import 'default-passive-events'
import '@/assets/atom.css';
import '@/assets/base.scss';
import '@/assets/defaultPage.scss';
import '@/assets/font/iconfont.css';
import 'nprogress/nprogress.css';
console.log(process.env.VITE_BASE_URL);
console.log(process.env.VITE_START_MODE);
// 引入axios
import axios from './data/request';
window.axios = axios;
import api from './data/fetchType';
import { baseURL, wsURL, isOpenWs, isMock, getGlobalConfig } from './config';
//路由守卫
import '@/router/routeGuard';
//配置接口地址
Vue.prototype.isOpenWs = isOpenWs;
Vue.prototype.wsURL = wsURL;
Vue.prototype.baseURL = baseURL;
Vue.prototype.getGlobalConfig = getGlobalConfig;
Vue.prototype.$api = api;
import jhCore from '@/jh/modules/jh-core/src';
Vue.use(jhCore, router, resetRouter, getGlobalConfig);
import jhMessage from '@/jh/modules/jh-message/src';
Vue.use(jhMessage, router, resetRouter, getGlobalConfig);
import jhAuth from '@/jh/modules/jh-auth/src';
Vue.use(jhAuth, router, resetRouter, getGlobalConfig);
import jhBase from '@/jh/modules/jh-base/src';
Vue.use(jhBase, router, resetRouter, getGlobalConfig);
import jhLog from '@/jh/modules/jh-log/src';
Vue.use(jhLog, router, resetRouter, getGlobalConfig);
import jhTask from '@/jh/modules/jh-task/src';
Vue.use(jhTask, router, resetRouter, getGlobalConfig);
import jhEncrypt from '@/jh/modules/jh-encrypt/src';
Vue.use(
  jhEncrypt,
  {
    SM4Key: 'jhkj@123pass#678',
    tripleDESKey: 'jhkj@123pass#67801234567'
  },
  getGlobalConfig
);
// import jhSso from "jh-sso";
// console.log(jhSso);
// var sso = jhSso.init({
//   urlParamKey: "portal_sso_login_ticket",
//   headerKey: "Portal-SSO-Auth-Ticket",
//   ssoUrl: "http://115.233.221.131:26201",
//   redirectUrl: "#/home"
// });
// import jhFormTemplate from 'jh-form-template';
// Vue.use(jhFormTemplate,router,resetRouter,getGlobalConfig);
// import jhFileTemplate from 'jh-file-template';
// Vue.use(jhFileTemplate,router,resetRouter,getGlobalConfig);

//mock数据
if (isMock && process.env.NODE_ENV === 'development') {
  const mockXHR = require('../mock');
  mockXHR.default();
}
//水印指令
import warterMark from '@/jh/functions/warterMark';
Vue.directive('warterMark', warterMark);
import plugin from './components';
import jhComponents from './jhComponents/index.js'; // 加载金惠公共组件

// 金惠公共组件
Object.keys(jhComponents).forEach((key) => {
  const name = key.replace(/(\w)/, (v) => v.toUpperCase());
  Vue.component(`${name}`, jhComponents[key]);
});
plugin(Vue);
//项目所有工具方法
import utils from './functions/utils';
Vue.use(utils);
//全局设置尺寸
console.log(ELEMENT);
ELEMENT.Form.props.labelWidth.default = '100px';
ELEMENT.TableColumn.props.showOverflowTooltip.default = true;
ELEMENT.TableColumn.props.align.default = 'center';
ELEMENT.Table.props.stripe.default = false;
ELEMENT.Table.props.border.default = true;
ELEMENT.Dialog.props.closeOnClickModal.default = false;
ELEMENT.Pagination.props.pageSizes.default = () => {
  return [20, 50, 100, 200];
};
ELEMENT.Pagination.props.background.default = true;
Vue.prototype.$ELEMENT.size = 'small';
Vue.config.productionTip = false;

import VueAnimateNumber from 'vue-animate-number';
Vue.use(VueAnimateNumber);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});
